module.exports = __webpack_public_path__ + "static/media/3ds Max.caa0f45e.png";